<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :has-form="true"
      title=""
      width="50%"
      class="my-test-class"
      @cancel="close"
      @confirm="handleConfirm"
    >
      <div style="margin-bottom:12px">
        <span>din码:</span>
        <gs-input
          v-model="din"
          style="width:150px"
        />
        <span>IP地址:</span>
        <gs-input
          v-model="ip"
          style="width:150px"
        />
        <gs-button @click="search">搜索</gs-button>
      </div>
      <gs-table
        v-loading="loading"
        ref="selectionTable"
        :data="tableData"
        style="width: 100%"
        @selection-change="getSelections"
      >
        <gs-table-column
          type="selection"
          fixed
        />
        <gs-table-column
          :show-overflow-tooltip="true"
          prop="name"
          label="设备名称"
          width="100"
        >
        <template slot-scope="scope">
          <span>{{scope.row.attribute.sn}}</span>
        </template>
        
      </gs-table-column>
        <gs-table-column
          :show-overflow-tooltip="true"
          prop="attribute.din"
          label="din码"
          min-width="120"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.attribute.isOnline"
              style='color:green'
            >{{scope.row.attribute.din}}</span>
            <span
              v-else
              style='color:red'
            >{{scope.row.attribute.din}}</span>
          </template>
        </gs-table-column>
        <gs-table-column
          :show-overflow-tooltip="true"
          prop="description"
          min-width="120"
          label="设备描述"
        />
        <gs-table-column
          :show-overflow-tooltip="true"
          prop="attribute.ip"
          min-width="120"
          label="IP地址"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.attribute.isOnline"
              style='color:green'
            >{{scope.row.attribute.ip}}</span>
            <span
              v-else
              style='color:red'
            >{{scope.row.attribute.ip}}</span>
          </template>
        </gs-table-column>
      </gs-table>
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import service from '../../service/leftService.js'
export default {
  data() {
    return {
      params: {
        pageSize: 5,
        pageNum: 1
      },
      din: '',
      ip: '',
      total: 0,
      pages: 0,
      tableData: [
      ],
      loading: false,
      selection: []
    }
  },
  computed: {
    ...mapState({
      visible: 'deviceListDialogShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
    visible() {
      this.getData()
    }
  },
  beforeMount() {

  },
  methods: {
    ...mapMutations({
      close: 'DEVICE_LIST_DIALOG_HIDE'
    }),
    handleConfirm() {
      // if (this.nodeData.id && this.nodeData.type === 'device') {
      //   let param = {
      //     id: this.nodeData.id,
      //     'name': this.name,
      //     'type': 'device',
      //     value: this.nodeData.value,
      //     'parentId': this.nodeData.parentId,
      //     'description': this.description,
      //     'attribute': this.form // 其他信息这里，键值对形式
      //   }
      //   service.renamePoint(param).then(res => {
      //     if (res.code) {
      //       this.$Message.error(res.message)
      //       this.loading = false
      //     } else {
      //       this.loading = false
      //       this.$Message.success('修改成功')
      //       this.close()
      //       this.needReload()
      //     }
      //   })
      // } else {
      // let param = {
      //   'name': this.name,
      //   'type': 'device',
      //   'parentId': this.nodeData.id,
      //   'description': this.description,
      //   'attribute': this.form // 其他信息这里，键值对形式
      // }
      this.selection.forEach(e => {
        for (let i in e) {
          if (!e[i]) {
            delete e[i]
          }
        }
      })
      service.saveDevices(this.selection).then(res => {
        this.loading = false
        this.$Message.success('添加成功')
        this.$store.state.addTreeNode = res
        this.close()
      }).catch(err => {
        this.loading = false
        this.$Message.error(err.message)
      })
      // }
    },
    beforeClose() {
      this.close()
    },
    getData() {
      service.searchDevice(this.din, this.ip).then(res => {
        this.tableData = res
      })
    },
    search() {
      this.getData()
    },
    getSelections(selection) {
      let array = selection
      array.forEach(element => {
        element.parentId = this.nodeData.id
        element.fullName = this.nodeData.name + '-' + element.name
      })
      this.selection = selection
    }
  }
}
</script>
<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/deviceList/deviceList.vue